import "./App.css";
// import 'bootstrap/dist/css/bootstrap.min.css';
import { Container } from "react-bootstrap";
import { Routes, Route } from "react-router-dom";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import AuthGuardComponent from "./Components/Auth/AuthGuard";
import UserCapabilitiesProvider from "./Components/Auth/UserCapabilitiesProvider";
import NavbarComponent from "./Components/Navbar/Navbar";
import RoutesComponent from "./Routes/routes";
import SimpleFooter from "./Components/Footer/Footer";
import DocumentViewPage from "./Components/DocumentViewPage/DocumentViewPage";
import { ToastProvider } from "./Components/Common/Toast/context/toastContext";
import { ToastComponent } from "./Components/Common/Toast/ToastComponent";
import { ThemeProvider } from "./context/themeContext";

function App() {
  return (
    <Container fluid className="p-0 m-0 d-flex flex-column min-vh-100">
      <UnauthenticatedTemplate>
        {<AuthGuardComponent />}
      </UnauthenticatedTemplate>

      <AuthenticatedTemplate>
        <ThemeProvider>
          <UserCapabilitiesProvider>
            <ToastProvider>
              <NavbarComponent />

              {/* main grows to fill the space, pushing footer down */}
              <main className="flex-grow-1">
                <Routes>
                  <Route path="/*" element={<RoutesComponent />} />
                  <Route path="/document/:id" element={<DocumentViewPage />} />
                </Routes>
              </main>

              {/* mt-auto forces footer to the bottom */}

              <SimpleFooter className="mt-auto" />
              <ToastComponent />
            </ToastProvider>
          </UserCapabilitiesProvider>
        </ThemeProvider>

      </AuthenticatedTemplate>
    </Container>
  );
}

export default App;
